import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";
import { ContentType } from "@robe/core-types";
import { parseQueryParamsObject } from "@robe/core-utils";
import { mapFormFields } from "./mappers";

export interface GetContentTypesOptions {
  minimal?: boolean;
}

/**
 * Get all content types.
 * Original `fields` field is used only on BE, on FE it is mapped mostly for purposes of content validation schema.
 *
 * @param options.minimal Only `id`, `name`, `titlePropertySelector`, `single`, `routes` and `locales` fields of content type will be fetched.
 */
export const getContentTypes = (core: XcoreCore, options?: GetContentTypesOptions): BaseApiRequest<Array<ContentType>> =>
  core
    .fetch(`/api/content-types${parseQueryParamsObject(options)}`)
    .then<Array<ContentType>>((res) => res.json())
    .then<Array<ContentType>>((res) =>
      res.map(
        // Replace original `fields` with mapped fields
        ({ fields: _, ...rest }) => ({
          ...rest,
          /**
           * This is just an array of form fields mapped from all form tabs and rows resolved after fetch.
           * This is being used e.g. in content validation schema.
           * */
          ...(rest?.form && { fields: mapFormFields(rest.form) }),
          isLocalized: rest.locales.length > 0,
        })
      )
    );
